<template>
	<div>
		<v-btn plain outlined small :disabled="isDisabledDown" @click="setFontSize(stepProp * -1)" class="mr-1">
			<span class="font-weight-bold"> A- </span>
		</v-btn>
		<!-- <span> {{ $options.maxValuePx }} %</span> -->
		<v-btn plain outlined small :disabled="isDisabledUp" @click="setFontSize(stepProp)" class="ml-1">
			<span class="font-weight-bold"> A+</span>
		</v-btn>
	</div>
</template>
<script>
import i18n from './dictionary.js';
export default {
	name: 'FontSizeTicker',
	components: {},
	props: {
		stepSize: {
			type: Number,
			default: 0.1,
		},
		steps: {
			type: Number,
			default: 2,
		},
		upCount: {
			type: Boolean,
			default: false,
		},
		downCount: {
			type: Boolean,
			default: false,
		},
	},
	i18n,
	data() {
		return { isDisabledDown: false, isDisabledUp: false };
	},
	computed: {
		stepProp: {
			get() {
				return this.stepSize;
			},
		},
	},
	methods: {
		setFontSize(stepSize) {
			if (!stepSize) return 0;
			// console.log(stepSize);

			const stepPx = this.$options.defaultFontSizePx * stepSize;
			const stepRem = this.$options.defaultFontSizeRem * stepSize;

			// console.log('stepPx', stepPx);
			// console.log('stepRem', stepRem);

			for (const styleSheet of document.styleSheets) {
				for (const rule of styleSheet.cssRules) {
					if (rule.type === CSSRule.STYLE_RULE) {
						const { fontSize } = rule.style;

						// //lineHeight
						// // eslint-disable-next-line no-unused-vars
						// const [allLineHeight, numberLineHeight, unitLineHeight] = lineHeight.match(/^([\d.]+)(\D+)$/) || [];
						// // console.log('typeof number', typeof number);

						// if (unitLineHeight === 'rem') {
						// 	rule.style.lineHeight = `${+numberLineHeight + stepRem}rem`;
						// }
						// if (unitLineHeight === 'px') {
						// 	rule.style.lineHeight = `${+numberLineHeight + stepPx}px`;
						// }

						//fontSize
						// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
						const [allFontSize, numberFontSize, unitFontSize] = fontSize.match(/^([\d.]+)(\D+)$/) || [];

						// console.log('typeof number', typeof +numberFontSize);

						if (unitFontSize === 'rem') {
							rule.style.fontSize = `${+numberFontSize + stepRem}rem`;
						}
						if (unitFontSize === 'px') {
							rule.style.fontSize = `${+numberFontSize + stepPx}px`;
						}
					}
				}
			}
			const actualDefaultFontSizePx = Number(
				window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/)[0]
			).toFixed(1);
			const actualDefaultFontSizeRem = (actualDefaultFontSizePx / this.$options.defaultFontSizePx).toFixed(1);

			// console.log(actualDefaultFontSizeRem, this.$options.maxFontSizeRem);

			if (
				actualDefaultFontSizePx === this.$options.maxFontSizePx ||
				actualDefaultFontSizeRem === this.$options.maxFontSizeRem
			) {
				// console.log('max', actualDefaultFontSizePx, actualDefaultFontSizeRem);
				this.isDisabledUp = true;
				this.isDisabledDown = false;
			} else if (
				actualDefaultFontSizeRem === this.$options.minFontSizePx ||
				actualDefaultFontSizeRem === this.$options.minFontSizeRem
			) {
				// console.log('min', actualDefaultFontSizePx, actualDefaultFontSizeRem);
				this.isDisabledDown = true;
				this.isDisabledUp = false;
			} else {
				this.isDisabledDown = false;
				this.isDisabledUp = false;
			}
		},
	},
	created() {
		this.$options.defaultFontSizePx = Number(
			window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/)[0]
		);
		this.$options.defaultFontSizeRem = 1;

		// console.log(this.upCount, this.downCount);

		if (this.upCount) {
			// console.log('uppCount');
			this.$options.minFontSizePx = this.$options.defaultFontSizePx.toFixed(1);
			this.$options.minFontSizeRem = this.$options.defaultFontSizeRem.toFixed(1);
			this.$options.maxFontSizePx = (this.$options.defaultFontSizePx * (1 + this.steps * this.stepSize)).toFixed(1);
			this.$options.maxFontSizeRem = (this.$options.defaultFontSizeRem * (1 + this.steps * this.stepSize)).toFixed(1);
			this.isDisabledDown = true;
		} else if (this.downCount) {
			// console.log('downCount');
			this.$options.minFontSizePx = (this.$options.defaultFontSizePx * (1 - this.steps * this.stepSize)).toFixed(1);
			this.$options.minFontSizeRem = (this.$options.defaultFontSizeRem * (1 - this.steps * this.stepSize)).toFixed(1);
			this.$options.maxFontSizePx = this.$options.defaultFontSizePx.toFixed(1);
			this.$options.maxFontSizeRem = this.$options.defaultFontSizeRem.toFixed(1);
			this.isDisabledUp = true;
		} else {
			this.$options.minFontSizePx = (this.$options.defaultFontSizePx * (1 - this.steps * this.stepSize)).toFixed(1);
			this.$options.minFontSizeRem = (this.$options.defaultFontSizeRem * (1 - this.steps * this.stepSize)).toFixed(1);
			this.$options.maxFontSizePx = (this.$options.defaultFontSizePx * (1 + this.steps * this.stepSize)).toFixed(1);
			this.$options.maxFontSizeRem = (this.$options.defaultFontSizeRem * (1 + this.steps * this.stepSize)).toFixed(1);
		}
		// this.$options.stepPx = this.$options.defaultFontSizePx * this.stepProp;
		// this.$options.stepRem = this.$options.defaultFontSizeRem * this.stepProp;
	},
};
</script>
